<template>
  <div class="w80">
    <div class="mt-40 mb-70">
      <div class="news">支付信息<span style="margin-left:50px;font-size: 8px;color:red">{{showtips}}</span></div>
      <div class="pay">
        <p>
          <span>支付对象 &nbsp;：</span
          ><span>{{goodTetx}}</span>
        </p>
        <p>
          <span>支付金额 &nbsp;：</span>
          <span class="pays">￥</span>
          <span v-if="info.goodsType" class="pay_price">{{info.amount}}</span>
        </p>
        <div class="fdc">
          <p>支付方式&nbsp; :</p>
          <div class="fsc fl ml-20">
            <div :class="[index == 1?'we_chat fdc bor_grenn ':'we_chat fdc']" @click="onWeChat()">
              <img src="../../assets/images/WeChat.png" alt="" />
              <span>微信支付</span>
            </div>
            <div :class="[index ==2?'alipay fdc bor_grenn':'alipay fdc']" @click="onAlipay()">
              <img src="../../assets/images/Alipay.png" alt="" />
              <span>支付宝支付</span>
            </div>
          </div>
        </div>
        <div class="pay_code">
           <div id="qrcode" ref="qrcode"></div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import {alipay,native,getorderstatus} from '@/api/coment'
import QRCode from 'qrcodejs2'
export default {
  data() {
    return {
       info:{},
       title:'',
       index:0,
       show:false,
       seconds:0,
       goodTetx:'专家提问',
       showtips:null,
       time:'', //定时器
    };
  },
  created() {
    this.info = JSON.parse(localStorage.getItem('list'))
    this.goodTetx = localStorage.getItem('title')
    if(this.info.goodsId == 1 ||this.info.goodsId == 2 ||this.info.goodsId ==3){
         this.goodTetx= " 会员缴费";
    }
    this.setTimer();
    // this.getorderstatus();
  },
  methods:{
    //支付宝支付
    onAlipay(){
      this.index =2;
      let  outTradeNo= this.info.orderNo;
      let  subject='充值';
      let  totalAmount=this.info.amount;
       window.open("alipay_dialog?outTradeNo="+outTradeNo+"&subject="+subject+"&totalAmount="+totalAmount+"&body="+subject,"_blank","toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=600,left=500");
       this.showtips="【支付中...】";
       this.$message('请打开支付宝扫码支付');
       this.getorderstatus();
    },
    //微信支付
    onWeChat(){
      this.showtips="【支付中...】";
      this.$message('请打开微信扫码支付');
      this.index = 1;
      let postData = {
          outTradeNo:this.info.orderNo,
          totalAmount:this.info.amount*100,
          body:"支付"
      };
      native(postData).then((res)=>{
        if(res.code == 0 ){
          this.qrCode(res.code_url);
		      this.getorderstatus();
        }
      }).catch((err)=>{
		  this.$message.error('微信二维码生成失败')
	 });
    },
    //生成二维码
    qrCode(url){
      //在调用qrCode前使用js原生方法清空元素内容
      document.getElementById('qrcode').innerHTML = '';
      let qrcode = new QRCode('qrcode', {
          width: 140, //图像宽度
          height: 140, //图像高度
          colorDark : "#000000", //前景色
          colorLight : "#ffffff", //背景色
          typeNumber:4,
          correctLevel : QRCode.CorrectLevel.H
          //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
      });
       qrcode.clear() //清除二维码
       qrcode.makeCode(url) //生成另一个新的二维码
    },
    //定时器
    setTimer(){
      let time = 60;
      this.Timer = setInterval(()=>{
          if(time<=60){
            this.show = false;
            time = 60;
            clearInterval(this.Timer);
            return;
          }
          time --;
      },1000)
    },
    //查询订单状态
    getorderstatus(){
	     let intervalFunc = window.setInterval(()=>{
         this.seconds+=10;
          let postData ={OrderNo:this.info.orderNo};
          getorderstatus(postData).then((res)=>{
          if(res.code == 0){
              if(res.data.status == 1){
                window.clearInterval(intervalFunc);
                this.showtips="【支付成功】"
                this.$message({
                  message:'支付成功！',
                  type: 'success',
                  duration:1000,
                });
                this.$store.state.user.userInfo = null;
                this.$store.dispatch('user/getInfo');
                if(this.goodTetx != "专家提问"){
                    this.$router.push('/membership')
                }else{   //充值缴费
                    let url = sessionStorage.getItem('url');
                    this.$router.push(`/${url}`)
                }
              localStorage.removeItem('list')
              sessionStorage.removeItem('url')
              }else if(res.data.status ==2){
                // this.$message.error('支付失败哦！');
                 this.showtips="【支付失败哦！】"
              }else{
                // this.$message('请赶快去支付哦!')
                this.showtips= "【支付中！】"
              }
          }
        }).catch((err)=>{})
        if(this.seconds>180){
           window.clearInterval(intervalFunc);
        }
	   },10*1000);
    },
 	goBack(){
	  this.$router.go(-1);
	   // this.$router.replace({path: '/'});
	}
  },
  mounted(){
	if(window.history && window.history.pushState){
	  history.pushState(null, null, document.URL);
	  window.addEventListener('popstate', this.goBack, false);
	}
  },
  //销毁
  destroyed(){
	window.removeEventListener('popstate', this.goBack, false);
  },

};
</script>
<style scoped>
.w74 {
  width: 74%;
  margin: 0 auto;
}
.mb-70 {
  margin-bottom: 70px;
}
.mt-40 {
  margin-top: 40px;
}
.ml-20 {
  margin-left: 20px;
}
.fl {
  flex: 1;
}
.news {
  width: 100%;
  height: 51px;
  line-height: 51px;
  background: #eeeeee;
  padding-left: 20px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
.pay {
  margin-top: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
.pay p {
  padding: 10px 0px;
}
.pays {
  color: #ff7402;
  font-size: 14px;
}
.pay_price {
  color: #ff7402;
  font-size: 20px;
}
.we_chat {
  width: 134px;
  height: 35px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  /* border: 1px solid #68BE32; */
}
.we_chat img {
  width: 24px;
  height: 20px;
  margin-left: 20px;
}
.we_chat span {
  flex: 1;
  margin-left: 10px;
}

.bor_grenn{
   border: 1px solid #68be32;
}
.alipay {
  width: 134px;
  height: 35px;
  background: #ffffff;
  border: 1px solid #EEEEEE;
  margin-left: 20px;
}
.alipay img {
  width: 19px;
  height: 19px;
  margin-left: 20px;
}
.alipay span {
  flex: 1;
  margin-left: 10px;
}
.pay_code {
  padding: 30px 85px;
}
</style>



// WEBPACK FOOTER //
// src/view/other/payment.vue